import React from 'react';

const Footer = () => {
    return (
        <div className='text-center font-sans text-gray-600 pt-10 sm:pt-12 font-medium flex items-center justify-center h-[50vh] '>



            All Rights Reserved By &copy;Secure StoreHouse| 2022-2035


        </div>
    );
};

export default Footer;